module.exports = __webpack_public_path__ + "static/media/inventory.54883b65.gif";